import { Handle, Position } from '@xyflow/react';
import { useTranslate } from 'react-admin';

import NodeIcon from '../../components/NodeIcon';
import TrueFalseHandles from '../../components/TrueFalseHandles';
import NodeHeader from '../NodeHeader';
import NodeWrapper from '../NodeWrapper';

export default function IsFromQueueNode(): React.ReactElement {
  const translate = useTranslate();

  return (
    <NodeWrapper>
      <NodeHeader icon={<NodeIcon name='queue' />} title={translate('callflows.nodes.is_from_queue.name')} />
      <Handle type='target' position={Position.Left} id='is_from_queue-target' />
      <TrueFalseHandles />
    </NodeWrapper>
  );
}
